import React, { useContext, useEffect } from "react";

import { Card, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const useStyles = makeStyles(theme => {
	const nt = theme.newLayoutTokens;
	return {
		ticketHeader: {
			display: "flex",
			alignItems: "center",
			background: nt ? nt.surface : theme.palette.total,
			flex: "none",
			borderBottom: nt
				? `1px solid ${nt.divider}`
				: `1px solid ${theme.mode === "light" ? "rgba(30, 20, 60, 0.08)" : "rgba(255,255,255,0.08)"}`,
			boxShadow: nt
				? "none"
				: theme.mode === "light"
					? "0 1px 3px rgba(30, 20, 60, 0.05)"
					: "none",
			height: nt ? nt.heights.header : "68px",
			[theme.breakpoints.down("sm")]: {
				flexWrap: "wrap",
				height: 'max-content'
			},
		},
		backButton: {
			color: nt ? nt.textMuted : undefined,
			borderRadius: nt ? nt.radii.control : undefined,
		},
	};
});

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();
	const { setCurrentTicket } = useContext(TicketsContext);

	// Corrigido 2026-10-21: no layout mobile (TicketsAdvanced), a troca
	// entre a lista e a conversa e' guiada pelo TicketsContext
	// (currentTicket) + pela rota, nao por este history.push isolado -
	// sem limpar currentTicket aqui, a tela mobile ficava presa numa
	// conversa "fantasma" ao voltar (URL mudava pra /tickets mas o
	// estado que decide qual tela mostrar continuava achando que tinha
	// um ticket selecionado). Limpar o currentTicket e' inofensivo no
	// desktop (ele nao depende desse context pra nada).
	const handleBack = () => {
		setCurrentTicket({ id: null, uuid: null, code: null });
		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					className={classes.ticketHeader}
				>
					<Button color="primary" onClick={handleBack} className={classes.backButton}>
						<ArrowBackIos />
					</Button>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
